import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
// import { CreateCustomerForm } from "./create-customer-form";
import { Button } from "@/components/ui/button";

export function CreateCustomerButton() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="default">Create Customer</Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Create Customer</DialogTitle>
        </DialogHeader>
        {/* <CreateCustomerForm /> */}
      </DialogContent>
    </Dialog>
  );
}
